export const enum Approaches {
    RetrieveThenRead = "rtr",
    ReadRetrieveRead = "rrr",
    ReadDecomposeAsk = "rda"
}

export type AskRequestOverrides = {
    semanticRanker?: boolean;
    semanticCaptions?: boolean;
    excludeCategory?: string;
    top?: number;
    temperature?: number;
    promptTemplate?: string;
    promptTemplatePrefix?: string;
    promptTemplateSuffix?: string;
    suggestFollowupQuestions?: boolean;
};

export type AskRequest = {
    question: string;
    approach: Approaches;
    overrides?: AskRequestOverrides;
};

export type AskResponse = {
    messageId?: string;
    answer: string;
    links: Link[];
    azs_links: Link[];
    docs_guia?: Link[];
    docs_herramienta?: { title: string; id: number }[];
    thoughts: string | null;
    data_points: string[];
    scope: string;
    negocio: string;
    acceso:string;
    centro:string;
    docType:string;
    debug_data: string;
    error?: string;
    selected_button?: string;
    question_intention?: string;
    language?: string;
    chain_of_thought?: string;
};

export type ChatTurn = {
    user: string;
    assistant?: string;
};

export type Link = {
    id: string;
    sectionid: string;
    title: string;
    vigencia_dates: string;
    vigente: string;
};

export type ChatRequest = {
    token: string;
    history: ChatTurn[];
    approach: Approaches;
    scope: string;
    overrides?: AskRequestOverrides;
    selectedButton?: string;
    seccion?: string;
};

export type FeedBackReq = {
    messageId: string;
    Question: string;
    Answer: string;
    Scope: string;
    Negocio: string;
    Acceso: string;
    Centro: string;
    Docs_respuesta: Link[];
    Docs_otros_enlaces: Link[];
    Content: {
        OK: boolean;
        FeedbackComment: string;
    };
    Links: {
        OK: boolean;
        FeedbackComment: string;
    };
    Reason: {
        OK: boolean;
        FeedbackComment: string;
    };
    OverallFeedback: string;
    PartitionKey: string;
    ButtonClickTime: number;
    selected_button: string;
    question_intention: string;
    language: string;
    chain_of_thought: string;
};

export type FeedBackRes = {
    message: string;
    error?: string;
};

export type dataUserReq = {
    user_id?: string;
    password: string;
    negocio: string;
    scope: string;
    isTest: string;
    startTime?: number;
};

export type dataUserRes = {
    response: string;
    error?: unknown;
};

export type dataFavQuestionsReq = {
    question: string;
    scope: string;
    acceso: string;
    ButtonClickTime: number;
};

export type dataFavQuestionsRes = [
    {
        question?: string;
        error?: string;
    }
];
export type Canalizacion = {
    category15_ids: number[];
    category15_names: string[];
};

export type PriorityGroups = {
    priorityGroups_groupIds: number[];
    priorityGroups_groupNames: string[];
    priorityGroups_valueIds: number[];
    priorityGroups_valueNames: string[];
    priorityGroups_groupLenghts: number[];
};

export type loginTokenResponse = {
    status: number;
    error?: string;
    scope: string;
    user: string;
    message?: string;
    origin?: string;
    canalizacion?: Canalizacion;
    priorityGroups?: PriorityGroups;
    pindi?: string;
    userDepartment?: string;
    salesMediaName?: string;
};

export type dataHistQuestionsRes = [
    {
        user_id: string;
        question: string;
        scope: string;
    }
];
